var React = require('react');

function Layers (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m12.3701 14.3c-.1 0-.19-.02-.28-.07l-9.40004-4.90001c-.2-.1-.32-.31-.32-.53s.12-.43.32-.53l9.40004-4.9c.17-.09.38-.09.55 0l9.4 4.9c.21.1.33.31.33.53s-.12.43-.32.53l-9.4 4.90001c-.09.05-.18.07-.28.07zm-8.10004-5.50001 8.10004 4.22001 8.1-4.22001-8.1-4.22zm8.09994 8.70001c-.1001 0-.19-.02-.28-.07l-9.40005-4.9c-.29-.15-.4-.51-.25-.81.15-.29.52-.41.81-.25l9.12005 4.75 9.12-4.76c.29-.15.66-.04.81.25s.04.66-.25.81l-9.4 4.9c-.0901.06-.18.08-.28.08zm-.28 3.13c.09.05.18.07.28.07s.19-.02.28-.08l9.4-4.9c.29-.15.4-.52.25-.81s-.52-.4-.81-.25l-9.12 4.76-9.12003-4.75c-.29-.16-.66-.04-.81.25-.16.29-.04.66.25.81z","fillRule":"evenodd"}));
}

Layers.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Layers;

Layers.default = Layers;
